import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
`;

export const Icon = styled.div`
    width: 26px;
    height: 26px;
    border-radius: 8px;
    background-color: #e9ecf2;
    object-fit: cover;
    margin-right: 6px; 
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        object-fit: cover;
        border-radius: 8px;
        margin: auto;
        width: 26px;
        height: 26px;
    }
`;

export const Label = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;